import { Link } from "react-router-dom";
import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import { IconArrow } from "../components/icons";
import styles from "./Participate.module.css";

const subNav = [
  { label: "Participate", path: "/participate", end: true },
  { label: "Get Involved", path: "/participate/get-involved" },
  { label: "Vending", path: "/participate/vending" },
  { label: "Sponsors", path: "/participate/sponsors" },
];

export default function Participate() {
  return (
    <>
      <PageHero
        eyebrow="Be part of it"
        title="Participate"
        lede="Three ways to roll up your sleeves: volunteer your time, vend your wares, or sponsor a children's music education program."
        image="/photos/volunteers.jpg"
      />
      <SubNav items={subNav} />

      <Page>
        <div className={styles.intro}>
          <p>
            Rhythms on the Rio is a 100% volunteer-built festival. Every shade
            structure, every gate, every sound check is the work of hundreds of
            people who show up early and leave late. Here's how to join them.
          </p>
        </div>

        <div className={styles.grid}>
          <Link to="/participate/get-involved" className={styles.card} style={{ backgroundImage: "url(/photos/volunteers.jpg)" }}>
            <div className={styles.cardOverlay} />
            <div className={styles.cardContent}>
              <span className={styles.eyebrow}>Volunteers · Street Team · ART</span>
              <h3>Get Involved</h3>
              <p>
                Free festival admission for an 8-hour shift. Promote the festival.
                Install your art for tens of thousands of eyes.
              </p>
              <span className={styles.arrow}>Read more <IconArrow /></span>
            </div>
          </Link>

          <Link to="/participate/vending" className={styles.card} style={{ backgroundImage: "url(/photos/festival-2.jpg)" }}>
            <div className={styles.cardOverlay} />
            <div className={styles.cardContent}>
              <span className={styles.eyebrow}>Food · Goods · Nonprofits</span>
              <h3>Vending</h3>
              <p>
                Booths, requirements, fees, and operational hours. 2026 vending is
                currently sold out — get on the list for 2027.
              </p>
              <span className={styles.arrow}>Read more <IconArrow /></span>
            </div>
          </Link>

          <Link to="/participate/sponsors" className={styles.card} style={{ backgroundImage: "url(/photos/festival-3.jpg)" }}>
            <div className={styles.cardOverlay} />
            <div className={styles.cardContent}>
              <span className={styles.eyebrow}>Brands & Partners</span>
              <h3>Sponsors</h3>
              <p>
                Stage naming, on-site activations, digital promotion. Every sponsor
                dollar goes back into instruments and lessons for kids.
              </p>
              <span className={styles.arrow}>Read more <IconArrow /></span>
            </div>
          </Link>
        </div>
      </Page>
    </>
  );
}
